import { SponsorshipVoucherFormData } from 'modules/auth/hooks/useSponsorshipVoucherForm'
import { Illustration } from 'modules/common/components/Illustrations/Illustration'
import { TextField } from 'modules/common/components/_ui/FormControl/TextField/TextField'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { UseFormReturn } from 'react-hook-form'

interface Props {
  form: UseFormReturn<SponsorshipVoucherFormData>
}

export const SponsorshipVoucherFormModalContent = ({ form }: Props) => {
  const { t } = useTranslation('auth-components')
  const {
    control,
    register,
    formState: { errors },
  } = form

  return (
    <div>
      <Illustration name="sponsorship" size="m" />
      <h2 className="pt-6">{t('sponsorshipVoucherFormModal.title')}</h2>
      <p className="pt-4">{t('sponsorshipVoucherFormModal.description')}</p>
      <TextField
        className="mt-8"
        id="voucherCode"
        label={t('sponsorshipVoucherFormModal.voucherCode.label')}
        control={control}
        error={errors?.voucherCode}
        isRequired
        {...register('voucherCode')}
      />
    </div>
  )
}
